import React, { useState, useEffect } from "react";
import "./manage-users.css";
import {
  Dropdown,
  Divider,
  Box,
  Button,
  Table,
  FormButton,
  FormInput,
  Form,
  TeamCreateIcon,
  MenuButton,
  Avatar,
  MoreIcon,
  EditIcon,
  Input,
  FormField,
  FormLabel,
  FormMessage,
} from "@fluentui/react-northstar";

import axios from "axios";

import { useNavigate } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import UsersService from "../apiservices/UsersService";
import TagsService from "../apiservices/TagsService";

const ManageUsers = () => {
  const [activeUsers, setActiveUsers] = useState([]);
  const [buttonPressed, setButtonPressed] = useState(false);
  const [userPressed, setUserPressed] = useState(false);
  const [netUserMail, setNewUserMail] = useState("");
  const [newUserFirstName, setNewUserFirstName] = useState("");
  const [newUserLastName, setNewUserLastName] = useState("");
  const [newUserPassword, setNewUserPassword] = useState("");
  const [newUserRetypePassword, setNewUserRetypePassword] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);

  const [activeFeatures, setActiveFeatures] = useState([
    "CDR",
    "Realtime",
    "Stats",
    "API",
    "Manage Groups",
    "Manage Users",
    "Tags",
  ]);

  const [isCdr, setidCdr] = useState(false);
  const [isStats, setIsStats] = useState(false);
  const [isRealtime, setIsRealTime] = useState(false);
  const [isTags, setIsTags] = useState(false);
  const [isApi, setIsApi] = useState(false);
  const [isManageUsers, setIsManageUsers] = useState(false);
  const [isManageGroups, setIsManageGroups] = useState(false);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [editUsername, setEditUsername] = useState("");
  const [editFirstName, setEditFirstName] = useState("");
  const [editLastName, setEditLastName] = useState("");
  const [editPermissions, setEditPermissions] = useState([]);
  const [editPhoto, setEditPhoto] = useState("");

  const [indicator, setIndicator] = useState(false);

  function featureSelected(feature) {
    if (feature === "CDR") {
      setidCdr(true);
    }
    if (feature === "Realtine") {
      setIsRealTime(true);
    }
    if (feature === "Stats") {
      setIsStats(true);
    }
    if (feature === "API") {
      setIsApi(true);
    }
    if (feature === "Manage Groups") {
      setIsManageGroups(true);
    }
    if (feature === "Manage Users") {
      setIsManageUsers(true);
    }
    if (feature === "Tags") {
      setIsManageUsers(true);
    }
  }
  function getActiveUsers(username) {
    UsersService.getUsers(username)
      .then((response) => {
        console.log(response.data);
        getActiveUsersToObject(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  }

  function handleRowClick(username) {
    setEditPhoto("");
    setIsAdmin(false);
    setButtonPressed(false);
    setIsSubmitting(true);
    UsersService.getUserInfo(username)
      .then((response) => {
        setEditUsername(response.data[0].username);
        setEditFirstName(response.data[0].firstName);
        setEditLastName(response.data[0].lastName);
        const arrayPermissions = [];
        if (response.data[0].cdr === true) {
          arrayPermissions.push("CDR");
        }
        if (response.data[0].stats === true) {
          arrayPermissions.push("Stats");
        }
        if (response.data[0].api === true) {
          arrayPermissions.push("API");
        }
        if (response.data[0].realtime === true) {
          arrayPermissions.push("Realtime");
        }
        if (response.data[0].manageGroups === true) {
          arrayPermissions.push("Manage Groups");
        }
        if (response.data[0].manageUsers === true) {
          arrayPermissions.push("Manage Users");
        }
        if (response.data[0].tags === true) {
          arrayPermissions.push("Tags");
        }
        if (response.data[0].role === "Admin") {
          setIsAdmin(true);
        }
        setEditPermissions(arrayPermissions);
        const pToken = sessionStorage.getItem("pToken");
        axios
          .get(
            `https://graph.microsoft.com/v1.0/users/${response.data[0].username}/photo/$value`,
            {
              headers: {
                Authorization: `Bearer ${pToken}`,
              },
              responseType: "blob",
            }
          )
          .then((o) => {
            const url = window.URL || window.webkitURL;
            const blobUrl = url.createObjectURL(o.data);
            setEditPhoto(blobUrl);
          })
          .catch((e) => {
            console.log(e);
          });
        setUserPressed(false);
        setTimeout(function () {
          setUserPressed(true);
          setIsSubmitting(false);
        }, 3000);
      })

      .catch((e) => {
        console.log(e);
      });
  }

  function getActiveUsersToObject(users) {
    const usersObjectArray = [];
    for (let user of users) {
      const editCell = {
        content: (
          <>
            {isSubmitting ? (
              <Button
                style={{ paddingLeft: "5rem" }}
                tabIndex={-1}
                icon={<EditIcon />}
                circular
                text
                iconOnly
                title="More options"
              />
            ) : (
              <Button
                style={{ paddingLeft: "5rem" }}
                tabIndex={-1}
                icon={<MoreIcon />}
                circular
                text
                iconOnly
                title="More options"
              />
            )}
          </>
        ),
        truncateContent: true,
        onClick: (e) => {
          handleRowClick(user.username);
          e.stopPropagation();
        },
      };
      usersObjectArray.push({
        key: user._id,
        items: [
          {
            content: user.firstName + " " + user.lastName,
            key: user._id,
          },
          {
            key: "1-5",
            ...editCell,
          },
        ],
      });
      setActiveUsers(usersObjectArray);
    }
  }

  useEffect(() => {
    const username = sessionStorage.getItem("userName");

    getActiveUsers(username);
  }, []);

  const getA11ySelectionAgents = {
    onAdd: (item) => featureSelected(item),
    onRemove: (item) => `${item} has been removed.`,
    itemsCount: (count) => {
      let narration;

      if (count === 1) {
        narration = `${count} item is selected.`;
      } else if (count >= 2) {
        narration = `${count} items are selected.`;
      }

      return narration;
    },
  };

  const onSubmit = async () => {
    const userName = sessionStorage.getItem("userName");
    const token = sessionStorage.getItem("tokenStats");
    const company = sessionStorage.getItem("company");
    const bodyToPost = {
      username: netUserMail,
      firstName: newUserFirstName,
      lastName: newUserLastName,
      password: newUserPassword,
      rPassword: newUserRetypePassword,
      cdr: isCdr,
      api: isApi,
      realtime: isRealtime,
      stats: isStats,
      manageGroupos: isManageGroups,
      manageUsers: isManageUsers,
      tags: isTags,
      userAdmin: userName,
      role: "subUser",
      tokenLogin: token,
      company: company,
    };
    console.log(bodyToPost);
    UsersService.postNewUser(bodyToPost)
      .then((response) => {
        confirmAlert({
          title: "Success!!",
          message: `User ${netUserMail} has been created`,
          buttons: [
            {
              label: "OK",
              onClick: () => window.location.reload(),
            },
          ],
        });
      })
      .catch((e) => {
        console.log(e);
      });
  };

  function onDeleteUser() {
    confirmAlert({
      title: "Are you sure to delete user?",
      message: `User ${editUsername} will be delete permanently`,
      buttons: [
        {
          label: "Continue",
          onClick: () => {
            UsersService.deleteUser(editUsername)
              .then((response) => {})
              .catch((e) => {
                console.log(e);
              });
            window.location.reload();
          },
        },
        {
          label: "Go Back",
        },
      ],
    });
  }

  const validateEmail = (email) => {
    return email
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const isUpper = (string) => /^[A-Z]*$/.test(string);

  return (
    <>
      <div className="tagsBody">
        <h1>MANAGE USERS</h1>
        <h2>Here you can manage your users and their respective roles</h2>
        <div className="dividerTags">
          <Divider />
        </div>
        <div className="activeGroups">
          <div style={{ marginTop: "10px" }}>
            <Button
              circular
              iconOnly
              icon={<TeamCreateIcon />}
              title="Add new group"
              onClick={() => {
                setButtonPressed(true);
                setUserPressed(false);
              }}
            />{" "}
            Add new USER
          </div>
          <div className="newUserForm">
            <div className="activeUsers">
              <h4>My active USERS </h4>

              <Box
                content="Box"
                styles={{
                  border: "1px #ccc",
                  color: "black",
                  textAlign: "Left",
                  width: "200px",
                  height: "100%",

                  // ":hover": {
                  //   color: "red",
                  // },
                }}
              >
                <Table
                  compact
                  style={{
                    width: 350,
                    textAlign: "right",
                  }}
                  variables={{
                    cellContentOverflow: "none",
                  }}
                  rows={activeUsers}
                  aria-label="Compact view static table"
                />
              </Box>
            </div>
            <div className="addGroup">
              {buttonPressed ? (
                <div>
                  <div className="addGroupTittle">
                    <b> New USER form</b>
                    <Divider />
                    <div className="formDiv">
                      <Form
                        onSubmit={() => {
                          onSubmit();
                        }}
                      >
                        <FormInput
                          label="Mail"
                          name="Mail"
                          id="Mail"
                          required
                          onChange={(e, v) => {
                            const isValid = validateEmail(v.value);
                            if (isValid) {
                              setIndicator(true);
                            }
                            setNewUserMail(v.value);
                          }}
                          showSuccessIndicator={indicator}
                        />
                        <div className="firstNameAndLastName">
                          <div className="firstName">
                            <FormInput
                              label="First Name"
                              name="First Name"
                              id="First Name"
                              required
                              onChange={(e, v) => {
                                setNewUserFirstName(v.value);
                              }}
                            />
                          </div>
                          <div className="lastName">
                            <FormInput
                              label="Last Name"
                              name="Last Name"
                              id="Last Name"
                              required
                              onChange={(e, v) => {
                                setNewUserLastName(v.value);
                                if (v.value === v.value.toUpperCase()) {
                                  console.log(true);
                                }
                              }}
                            />
                          </div>
                        </div>
                        <div className="passwordAndRetypePassword">
                          <FormInput
                            type="password"
                            label="Password"
                            name="Password"
                            id="Password"
                            required
                            onChange={(e, v) => {
                              const isUpperCase = isUpper(v.value);
                              console.log(isUpperCase);
                              if (
                                v.value.length > 10 &&
                                isUpper(v.value) === true
                              ) {
                                setIndicator(true);
                              }
                              setNewUserPassword(v.value);
                            }}
                            showSuccessIndicator={indicator}
                          />
                          <div className="retypePassword">
                            <FormInput
                              type="password"
                              label="Retype Password"
                              name="Retype Password"
                              id="Retype Password"
                              onChange={(e, v) => {
                                setNewUserRetypePassword(v.value);
                              }}
                              required
                            />
                          </div>
                        </div>
                        <Dropdown
                          activeSelectedIndex
                          search
                          multiple
                          items={activeFeatures}
                          placeholder="Select features"
                          getA11ySelectionMessage={getA11ySelectionAgents}
                          noResultsMessage="We couldn't find any matches."
                          a11ySelectedItemsMessage="Press Delete or Backspace to remove"
                        />
                        <FormButton content="Create User" />
                      </Form>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
              {isSubmitting && (
                <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
              )}
              {userPressed ? (
                <div style={{ marginTop: -40 }}>
                  <div className="addGroupTittle">
                    <h4>
                      <Avatar
                        name={editFirstName}
                        image={editPhoto}
                        size="larger"
                      />
                      <b> Editing user {editUsername}</b>{" "}
                    </h4>
                    <Divider />
                    <div className="formDiv">
                      <Form>
                        <FormInput
                          disabled
                          label="Mail"
                          name="Mail"
                          id="Mail"
                          placeholder={editUsername}
                          onChange={(e, v) => {
                            setNewUserMail(v.value);
                          }}
                        />

                        <div className="firstNameAndLastName">
                          <div className="firstName">
                            <FormInput
                              disabled
                              label="Last Name"
                              name="Last Name"
                              id="Last Name"
                              placeholder={editFirstName}
                              onChange={(e, v) => {
                                setNewUserFirstName(v.value);
                              }}
                            />
                          </div>
                          <div className="lastName">
                            <FormInput
                              disabled
                              label="Last Name"
                              name="Last Name"
                              id="Last Name"
                              placeholder={editLastName}
                              onChange={(e, v) => {
                                setNewUserLastName(v.value);
                              }}
                            />
                          </div>
                        </div>
                        <div className="passwordAndRetypePassword">
                          <FormInput
                            type="password"
                            label="Change Password"
                            name="Change Password"
                            id="Change Password"
                            onChange={(e, v) => {
                              setNewUserPassword(v.value);
                            }}
                            showSuccessIndicator={false}
                          />
                          <div className="retypePassword">
                            <FormInput
                              type="password"
                              label="Retype Changed Password"
                              name="Retype Changed Password"
                              id="Retype Changed Password"
                              onChange={(e, v) => {
                                setNewUserRetypePassword(v.value);
                              }}
                            />
                          </div>
                        </div>
                        {isAdmin === true ? (
                          <div> Admin Permissions : all</div>
                        ) : (
                          <div>
                            Permissions* <br></br>
                            <Dropdown
                              activeSelectedIndex
                              style={{ marginTop: 3 }}
                              search
                              multiple
                              items={activeFeatures}
                              label="Permissions"
                              placeholder="Select features"
                              defaultValue={editPermissions}
                              getA11ySelectionMessage={getA11ySelectionAgents}
                              noResultsMessage="We couldn't find any matches."
                              a11ySelectedItemsMessage="Press Delete or Backspace to remove"
                            />
                          </div>
                        )}
                        <div
                          style={{
                            display: "flex",
                          }}
                        >
                          <Button primary content="Apply Changes" />
                          {isAdmin === true ? (
                            ""
                          ) : (
                            <Button
                              onClick={() => onDeleteUser()}
                              styles={{
                                marginLeft: "20px",
                                color: "white",
                                backgroundColor: "#A80000",
                              }}
                              content="Delete User"
                            />
                          )}
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageUsers;
